import { IncludeTypeNumber } from '@gn-audio/core';
import { ItemType } from '@gn-audio/jss-core';

export interface ProductEOLParams {
  itemType: ItemType;
  groupState: IncludeTypeNumber;
  familyState: IncludeTypeNumber;
}

/**
 * Determines whether a product is considered End-of-Life (EOL) based on its type and state.
 *
 * @param itemType - The type of the product item ('Family' or 'Group').
 * @param groupState - The current state of the product group, represented as an `IncludeTypeNumber`.
 * @param familyState - The current state of the product family, represented as an `IncludeTypeNumber`.
 * @returns `true` if the product is EOL (i.e., its state is less than `IncludeTypeNumber.Available`), otherwise `false`.
 */
export const isProductEOL = ({ itemType, groupState, familyState }: ProductEOLParams): boolean => {
  if (!itemType || groupState === undefined || familyState === undefined) {
    return false;
  }

  switch (itemType) {
    case 'Family':
      return familyState < IncludeTypeNumber.Available;
    case 'Group':
      return groupState < IncludeTypeNumber.Available;
    default:
      return false;
  }
};
